import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Card, Col, List, Row } from "antd";
//Ducks
import * as reqDuck from "../../../../redux/aspirante/reqAcademicoDuck";
import { getAllCatalogos } from "../../../../redux/aspirante/catalogoDucks";
//Componentes
import { UpdateArchivo } from "./UpdateArchivo";
import { DescripcionArchivo } from "./DescripcionArchivo";
import { getColorCotejo } from "../../../../utils";

/**
 * Componente que muestra la lista de req. Académicos  en la pantalla de expediente digital
 */
export const ListaAcademica = () => {
  const dispatch = useDispatch();
  //State
  const { loading, historial } = useSelector((state) => state.reqAcademico);
  const { updateDocumento } = useSelector((state) => state.reqAcademico);
  const { catalogoExpediente } = useSelector((state) => state.expDigital);

  //------------------- Se cargan los catálogos --------------------------------------
  useEffect(() => {
    dispatch(getAllCatalogos());
    dispatch(reqDuck.getHisAcademicoById());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      dispatch(reqDuck.delDocumentoUpd());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //-------------------Fin useEffect --------------------------------------------------

  // const getTextCotejo = (id) => (TEXTOS[id] ? TEXTOS[id] : "");

  const getTextCotejo = (id) =>
    catalogoExpediente.find(({ idEstatus }) => idEstatus === +id);

  const HeaderComponent = () => {    
    const estatus = getTextCotejo(historial[0]?.cotejo);    
    return (
      <>
        {estatus && estatus?.idEstatus !== 1 ? (
          <Badge.Ribbon
            text={estatus?.nombre}
            color={getColorCotejo(estatus?.idEstatus)}
          >
            <div className="list-header">Listado de documentos académicos</div>
          </Badge.Ribbon>
        ) : (
          <div className="list-header">Listado de documentos académicos</div>
        )}
      </>
    );
  };
  return (
    <div>
      <div className=" exp-formato-fondo">
        <div className="exp-formato-content">
          <h3 style={{ fontWeight: 300 }}>Descripción:</h3>
          {catalogoExpediente.map((item, i) => (
            <Row key={i}>
              <Col span={1} xxl={1} xl={1} lg={1} md={1} sm={24} xs={24}>
                <div className="exp-numero-requisito">{i + 1}</div>
              </Col>
              <Col span={23} xxl={23} xl={23} lg={23} md={23} sm={24} xs={24}>
                <div className="exp-estatus">
                  <b>{item.nombre}</b> : {item.descripcion}
                </div>
              </Col>
            </Row>
          ))}
        </div>
      </div>
      <List
        className="list-academicos"
        loading={loading}
        header={<HeaderComponent />}
        bordered
        dataSource={historial}
        style={{ overflow: "auto" }}
        renderItem={(item) => (
          <List.Item>
            <Card hoverable className="card-content" key={item.id}>
              {/* Componente que muestra el nombre del archivo con las acciones de descarga y actualización */}
              <DescripcionArchivo item={item} />

              {/* Componente que muestra el nuevo documento a actualizar del req. académico */}
              {Object.keys(updateDocumento).length > 0 &&
                updateDocumento.idEscolaridad === item?.idEscolaridad && (
                  <div style={{ marginTop: 10 }}>
                    <UpdateArchivo />
                  </div>
                )}
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};
